import React from 'react';
import TimeFilter from './TimeFilter';
import MessageList from './MessageList';

/**
 * Chat Body Component
 * Contains the time filter and message list
 *
 * @param {Object} props
 * @param {Array} props.messages - Array of chat messages
 * @param {boolean} props.isLoading - Loading state
 * @param {string} props.error - Error message if any
 * @param {Date} props.filterDate - Current filter date (from date)
 * @param {Date} props.filterEndDate - Current filter end date (to date)
 * @param {Function} props.onFilterChange - Callback when filter changes
 * @param {Function} props.onRefresh - Callback to refresh messages
 * @param {Object} props.user - Current user info
 * @param {Object} props.activity - Activity object containing date information
 */
const ChatBody = ({
    messages,
    isLoading,
    error,
    filterDate,
    filterEndDate,
    onFilterChange,
    onRefresh,
    user,
    activity
}) => {
    return (
        <div className="chat-body">
            {/* Time Filter Section */}
            <TimeFilter
                filterDate={filterDate}
                filterEndDate={filterEndDate}
                onFilterChange={onFilterChange}
                messageCount={messages.length}
                activity={activity}
            />

            {/* Messages Section */}
            <MessageList
                messages={messages}
                isLoading={isLoading}
                error={error}
                user={user}
            />
        </div>
    );
};

export default ChatBody;